module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Media/DVD-a57835f20733e83c6016687ebef71918fc90d25142e2080991ec1513aed7a805.svg";